import redux, { Dispatch, Reducer } from 'redux'
import { GetState } from './index'

export interface QuoteState {
  created?: number
  paymentTerm: string
  person: any
  address: any
  building: any
  additional: any
}

type ActionTypes = 'QUOTE_RESET' | 'QUOTE_PERSON' | 'QUOTE_ADDRESS' | 'QUOTE_BUILDING' | 'QUOTE_ADDITIONAL' | 'QUOTE_PAYMENT_TERM';
type Action = redux.Action<ActionTypes> & redux.AnyAction

const initialState: QuoteState = {
  paymentTerm: 'monthly',
  person: {},
  address: {},
  building: {},
  additional: {},
}

export const actionTypes: {[key: string]: ActionTypes} = {
  RESET: 'QUOTE_RESET',
  PERSON: 'QUOTE_PERSON',
  ADDRESS: 'QUOTE_ADDRESS',
  BUILDING: 'QUOTE_BUILDING',
  ADDITIONAL: 'QUOTE_ADDITIONAL',
  PAYMENT_TERM: 'QUOTE_PAYMENT_TERM',
};

export const quote: Reducer<QuoteState, Action> = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.RESET:
      return Object.assign({}, initialState);

    case actionTypes.PERSON:
      return Object.assign({}, state, {
        created: Date.now(),
        person: action.person,
      });

    case actionTypes.ADDRESS:
      return Object.assign({}, state, {
        created: Date.now(),
        address: action.address,
      });

    case actionTypes.BUILDING:
      return Object.assign({}, state, {
        created: Date.now(),
        building: action.building,
      });

    case actionTypes.ADDITIONAL:
      return Object.assign({}, state, {
        created: Date.now(),
        additional: action.additional,
      });

    case actionTypes.PAYMENT_TERM:
      return Object.assign({}, state, {
        created: Date.now(),
        paymentTerm: action.paymentTerm,
      });

    default:
      return state
  }
};

export type resetType = () => any
export const reset = () => async (dispatch: any) => {
  await dispatch({
    type: actionTypes.RESET
  })
}

export type setPersonType = (person: any) => any
export const setPerson = (person: any) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  await dispatch({
    type: actionTypes.PERSON,
    person,
  })
}

export type setBuildingType = (person: any) => any
export const setBuilding = (building: any) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  await dispatch({
    type: actionTypes.BUILDING,
    building,
  })
}

export type setAdditionalType = (additional: any) => any
export const setAdditional = (additional: any) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  await dispatch({
    type: actionTypes.ADDITIONAL,
    additional,
  })
}

export type setAddressType = (address: any) => any
export const setAddress = (address: any) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  await dispatch({
    type: actionTypes.ADDRESS,
    address,
  })
}

export type setPaymentTermType = (paymentTerm: string) => any
export const setPaymentTerm = (paymentTerm: string) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  await dispatch({
    type: actionTypes.PAYMENT_TERM,
    paymentTerm,
  })
}

export const quoteInitialize = () => async (dispatch: Dispatch<Action>) => {
  // await handleUser(userPool.getCurrentUser(), dispatch)
}
